export default "__VITE_ASSET__mUvZIbwM__"